define('pages/track-page',["require", "exports", "../baseline/hotkeys", "../baseline/translate", "../charts/distance-overlay", "../charts/flight-stats", "../charts/multichart", "../charts/polar", "../charts/timechart", "../maps/track-map", "../tracks/starred", "../tracks/track-enabled", "../tracks/track-settings", "../tracks/track-stats", "../tracks/video-play", "../views/hover-title"], function (require, exports, hotkeys, translate, distanceOverlay, flightStats, multichart_1, polar, timechart, map, starred, trackEnabled, trackSettings, trackStats, video, hoverTitle) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    function init(trackId, userId) {
        trackSettings.init(trackId, userId);
        trackStats.init(trackId); // TODO: Does this do anything?
        map.init(trackId, userId);
        video.init(trackId);
        timechart.init(trackId);
        flightStats.init(true);
        polar.init();
        hotkeys.init();
        translate.init(trackId, userId);
        hoverTitle.init();
        distanceOverlay.init();
        starred.init(userId);
        new multichart_1.MultiChart();
        trackEnabled.addTrack(trackId);
    }
    exports.init = init;
});
//# sourceMappingURL=/assets/javascripts/pages/track-page.js.map;
